import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { purchasePackage } from '../../services/revenueCatService';
import { useAuth } from '../../contexts/AuthContext';

export default function Subscribe() {
    const location = useLocation();
    const navigate = useNavigate();
    const [error, setError] = useState<string | null>(null);
    const productId = location.state?.productId;
    const { user } = useAuth();

    useEffect(() => {
        if (!productId) {
            navigate('/pricing', { 
                state: { 
                    error: 'Invalid plan selected. Please try again.' 
                }
            });
            return;
        }

        const handleSubscription = async () => {
            try {
                if (!user) {
                    throw new Error('You must be logged in to subscribe');
                }

                await purchasePackage(productId);
                navigate('/account', {
                    state: { success: 'Subscription activated successfully!' }
                });
            } catch (err) {
                const message = err instanceof Error ? err.message : 'An unexpected error occurred';
                if (message === 'Purchase cancelled by user') {
                    navigate('/pricing');
                    return;
                }
                
                setError(message);
                setTimeout(() => {
                    navigate('/pricing', { 
                        state: { error: message }
                    });
                }, 3000);
            }
        };

        handleSubscription();
    }, [productId, user, navigate]);

    if (error) {
        return (
            <div className="min-h-screen flex items-center justify-center px-4">
                <div className="bg-red-50 border border-red-200 rounded-lg p-4 max-w-md w-full">
                    <p className="text-red-600 text-center">{error}</p>
                    <p className="text-sm text-gray-500 text-center mt-2">
                        Redirecting back to pricing...
                    </p>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen flex items-center justify-center px-4">
            <div className="max-w-md w-full space-y-8 text-center">
                <div className="animate-pulse space-y-4">
                    <div className="mx-auto h-12 w-12 rounded-full bg-blue-200" />
                    <div className="space-y-2">
                        <div className="h-4 bg-blue-200 rounded mx-auto max-w-[200px]" />
                    </div>
                </div>
                <p className="text-sm text-gray-500">
                    Setting up your subscription...
                </p>
            </div>
        </div>
    );
}